/* istanbul ignore file */
import Select from './Select';

export default Select;
